import React from "react";
import { ReactComponent as DoubleArrowsIcon } from "static/images/switch.svg";

const SwapInputsIcon = ({ onClick, ariaLabel }) => {
  return (
    <button
      type="button"
      className="otrl-jp__swap-input-icon otrl-jp__button-unstyled"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <DoubleArrowsIcon />
    </button>
  );
};

export default SwapInputsIcon;
